import { signalStore, withComputed, withHooks, withMethods, withProps, withState } from '@ngrx/signals';

import { authAdapterMethodsFactory } from './auth.adapter-methods';
import { authComputedSignalsFactory } from './auth.computed-signals';
import { authHooksFactory } from './auth.hooks';
import { authObservablePropsFactory } from './auth.observable-props';
import { initialState } from './auth.state';

export const AuthStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed(authComputedSignalsFactory),
  withProps(authObservablePropsFactory),
  withMethods(authAdapterMethodsFactory),
  withHooks(authHooksFactory),
);
